export default {
  upload: '/file/upload',
  info: '/file/info',
  download: '/file/download',
}



// WEBPACK FOOTER //
// ./src/api/file.api.js